/**
 * The ids a form field names in `aria-describedby`: its tip
 * (components/shared/InfoTip.tsx `FieldLabel`) and any line under it.
 */

/** The id under which a field's tip text sits. */
export function tipId(fieldId: string): string {
  return `${fieldId}-tip`
}

/** The ids a field's `aria-describedby` names, or undefined for none. */
export function describedBy(...ids: (string | false | undefined)[]): string | undefined {
  const named = ids.filter((id): id is string => typeof id === 'string' && id !== '')
  return named.length === 0 ? undefined : named.join(' ')
}
